<template>
<div>
    <h1 class="display-heading">Dashboard</h1>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Registered Corporate Customers</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalRegisteredCorporateCustomers" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalRegisteredCorporateCustomers">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalRegisteredCompanies.count}}</span>
                            <span class="ml-3">New Corporate Customer<span v-if="totalRegisteredCompanies.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Registered Corporate Employees</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalRegisteredCorporateEmployees" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalRegisteredCorporateEmployees">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalRegisteredCompanyEmployees.count}}</span>
                            <span class="ml-3">New Corporate Employee<span v-if="totalRegisteredCompanyEmployees.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Registered Doctors</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalRegisteredDoctors" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalRegisteredDoctors">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalRegisteredDoctors.count}}</span>
                            <span class="ml-3">New Doctor<span v-if="totalRegisteredDoctors.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Registered Patients</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalRegisteredPatients" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalRegisteredPatients">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalRegisteredPatients.count}}</span>
                            <span class="ml-3">New Patient<span v-if="totalRegisteredPatients.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Scheduled Appointments</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalScheduledAppointments" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalScheduledAppointments">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalScheduledConsultations.count}}</span>
                            <span class="ml-3">Doctor Appointment<span v-if="totalScheduledConsultations.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Paid Consultations</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalPaidAppointments" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalPaidAppointments">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalPaidConsultations.count}}</span>
                            <span class="ml-3">Paid Appointment<span v-if="totalPaidConsultations.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Cancelled Appointments</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalCancelledAppointments" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalCancelledAppointments">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">{{totalCancelledConsultations.count}}</span>
                            <span class="ml-3">Cancelled Appointment<span v-if="totalCancelledConsultations.count>1">s</span></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Received Amount for Doctor Appointments</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalCollectedConsultationAmount" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalCollectedConsultationAmount">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM {{totalCollectedConsultationAmount.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Payable Amount to Doctor Appointments</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalCollectedConsultationDoctorAmount" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalCollectedConsultationDoctorAmount">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM {{totalCollectedConsultationDoctorAmount.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row">
        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Received Amount to Prescribed Medicines</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalCollectedPrescriptionAmount" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalCollectedPrescriptionAmount">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalCollectedPrescriptionAmount.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-6">
             <div class="card mb-4">
                <div class="card-body">
                    <h5 class="mb-3">Total Payable Amount to Prescribed Medicines</h5>
                    <div class="d-flex mb-3">
                        <div class="mr-3 flex-grow-1">
                            <datetime-picker ref="totalCollectedPrescriptionPharmacyAmount" class="form-control"></datetime-picker>
                        </div>
                        <div>
                            <button class="btn btn-primary btn-primary-insv" @click="viewTotalCollectedPrescriptionPharmacyAmount">View</button>
                        </div>
                    </div>
                    <div class="d-flex justify-content-center">
                        <div class="dashboard-count">
                            <span class="digit">RM{{totalCollectedPrescriptionPharmacyAmount.amount.toFixed(2)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import moment from 'moment';
import datetimePicker from '@/components/datetime-picker';
export default {
    'name': 'SuperAdminDashboard',
    'components': {
        datetimePicker
    },
    data () {
        return {
            'totalRegisteredDoctors': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalRegisteredCompanies': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalRegisteredCompanyEmployees': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalScheduledConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalPaidConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalCancelledConsultations': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalRegisteredPatients': {
                'startDate': null,
                'endDate': null,
                'count': 0
            },
            'totalCollectedConsultationAmount': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalCollectedConsultationDoctorAmount': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalCollectedPrescriptionAmount': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            },
            'totalCollectedPrescriptionPharmacyAmount': {
                'startDate': null,
                'endDate': null,
                'amount': 0
            }
        };
    },
    mounted () {
        this.getDashboard();
    },
    'methods': {
        getDashboard () {
            this.axios.get('Dashboard/GetSuperAdminDashboard').then(({ data }) => {
                if (data.data.td) {
                    this.setTotalRegisteredDoctors(data.data.td);
                }

                if (data.data.tc) {
                    this.setTotalRegisteredCompanies(data.data.tc);
                }

                if (data.data.tce) {
                    this.setTotalRegisteredCompanyEmployees(data.data.tce);
                }

                if (data.data.tsc) {
                    this.setTotalScheduledConsultations(data.data.tsc);
                }

                if (data.data.tpc) {
                    this.setTotalPaidConsultations(data.data.tpc);
                }

                if (data.data.tcc) {
                    this.setTotalCancelledConsultations(data.data.tcc);
                }

                if (data.data.trp) {
                    this.setTotalRegisteredPatients(data.data.trp);
                }

                if (data.data.tcca) {
                    this.setTotalCollectedConsultationAmount(data.data.tcca);
                }

                if (data.data.tdca) {
                    this.setTotalCollectedConsultationDoctorAmount(data.data.tdca);
                }

                if (data.data.tcpa) {
                    this.setTotalCollectedPrescriptionAmount(data.data.tcpa);
                }

                if (data.data.tppa) {
                    this.setTotalCollectedPrescriptionPharmacyAmount(data.data.tppa);
                }
            });
        },
        setTotalRegisteredDoctors (data) {
            this.totalRegisteredDoctors.startDate = moment(data.sd);
            this.totalRegisteredDoctors.endDate = moment(data.ed);
            this.totalRegisteredDoctors.count = data.c;

            if (this.$refs.totalRegisteredDoctors) {
                this.$refs.totalRegisteredDoctors.setDate(this.totalRegisteredDoctors.startDate, this.totalRegisteredDoctors.endDate);
            }
        },
        setTotalRegisteredCompanies (data) {
            this.totalRegisteredCompanies.startDate = moment(data.sd);
            this.totalRegisteredCompanies.endDate = moment(data.ed);
            this.totalRegisteredCompanies.count = data.c;

            if (this.$refs.totalRegisteredCorporateCustomers) {
                this.$refs.totalRegisteredCorporateCustomers.setDate(this.totalRegisteredCompanies.startDate, this.totalRegisteredCompanies.endDate);
            }
        },
        setTotalRegisteredCompanyEmployees (data) {
            this.totalRegisteredCompanyEmployees.startDate = moment(data.sd);
            this.totalRegisteredCompanyEmployees.endDate = moment(data.ed);
            this.totalRegisteredCompanyEmployees.count = data.c;

            if (this.$refs.totalRegisteredCorporateEmployees) {
                this.$refs.totalRegisteredCorporateEmployees.setDate(this.totalRegisteredCompanyEmployees.startDate, this.totalRegisteredCompanyEmployees.endDate);
            }
        },
        setTotalScheduledConsultations (data) {
            this.totalScheduledConsultations.startDate = moment(data.sd);
            this.totalScheduledConsultations.endDate = moment(data.ed);
            this.totalScheduledConsultations.count = data.c;

            if (this.$refs.totalScheduledAppointments) {
                this.$refs.totalScheduledAppointments.setDate(this.totalScheduledConsultations.startDate, this.totalScheduledConsultations.endDate);
            }
        },
        setTotalPaidConsultations (data) {
            this.totalPaidConsultations.startDate = moment(data.sd);
            this.totalPaidConsultations.endDate = moment(data.ed);
            this.totalPaidConsultations.count = data.c;

            if (this.$refs.totalPaidAppointments) {
                this.$refs.totalPaidAppointments.setDate(this.totalPaidConsultations.startDate, this.totalPaidConsultations.endDate);
            }
        },
        setTotalCancelledConsultations (data) {
            this.totalCancelledConsultations.startDate = moment(data.sd);
            this.totalCancelledConsultations.endDate = moment(data.ed);
            this.totalCancelledConsultations.count = data.c;

            if (this.$refs.totalCancelledAppointments) {
                this.$refs.totalCancelledAppointments.setDate(this.totalCancelledConsultations.startDate, this.totalCancelledConsultations.endDate);
            }
        },
        setTotalRegisteredPatients (data) {
            this.totalRegisteredPatients.startDate = moment(data.sd);
            this.totalRegisteredPatients.endDate = moment(data.ed);
            this.totalRegisteredPatients.count = data.c;

            if (this.$refs.totalRegisteredPatients) {
                this.$refs.totalRegisteredPatients.setDate(this.totalRegisteredPatients.startDate, this.totalRegisteredPatients.endDate);
            }
        },
        setTotalCollectedConsultationAmount (data) {
            this.totalCollectedConsultationAmount.startDate = moment(data.sd);
            this.totalCollectedConsultationAmount.endDate = moment(data.ed);
            this.totalCollectedConsultationAmount.amount = data.a;

            if (this.$refs.totalCollectedConsultationAmount) {
                this.$refs.totalCollectedConsultationAmount.setDate(this.totalCollectedConsultationAmount.startDate, this.totalCollectedConsultationAmount.endDate);
            }
        },
        setTotalCollectedConsultationDoctorAmount (data) {
            this.totalCollectedConsultationDoctorAmount.startDate = moment(data.sd);
            this.totalCollectedConsultationDoctorAmount.endDate = moment(data.ed);
            this.totalCollectedConsultationDoctorAmount.amount = data.a;

            if (this.$refs.totalCollectedConsultationDoctorAmount) {
                this.$refs.totalCollectedConsultationDoctorAmount.setDate(this.totalCollectedConsultationDoctorAmount.startDate, this.totalCollectedConsultationDoctorAmount.endDate);
            }
        },
        setTotalCollectedPrescriptionAmount (data) {
            this.totalCollectedPrescriptionAmount.startDate = moment(data.sd);
            this.totalCollectedPrescriptionAmount.endDate = moment(data.ed);
            this.totalCollectedPrescriptionAmount.amount = data.a;

            if (this.$refs.totalCollectedPrescriptionAmount) {
                this.$refs.totalCollectedPrescriptionAmount.setDate(this.totalCollectedPrescriptionAmount.startDate, this.totalCollectedPrescriptionAmount.endDate);
            }
        },
        setTotalCollectedPrescriptionPharmacyAmount (data) {
            this.totalCollectedPrescriptionPharmacyAmount.startDate = moment(data.sd);
            this.totalCollectedPrescriptionPharmacyAmount.endDate = moment(data.ed);
            this.totalCollectedPrescriptionPharmacyAmount.amount = data.a;

            if (this.$refs.totalCollectedPrescriptionPharmacyAmount) {
                this.$refs.totalCollectedPrescriptionPharmacyAmount.setDate(this.totalCollectedPrescriptionPharmacyAmount.startDate, this.totalCollectedPrescriptionPharmacyAmount.endDate);
            }
        },
        viewTotalRegisteredCorporateCustomers () {
            let { startDate, endDate } = this.$refs.totalRegisteredCorporateCustomers.getDates();

            this.axios.post('Dashboard/GetTotalRegisteredCorporateCustomers',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalRegisteredCompanies(data.data);
            });
        },
        viewTotalRegisteredCorporateEmployees () {
            let { startDate, endDate } = this.$refs.totalRegisteredCorporateEmployees.getDates();

            this.axios.post('Dashboard/GetTotalRegisteredCorporateEmployees',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalRegisteredCompanyEmployees(data.data);
            });
        },
        viewTotalRegisteredDoctors () {
            let { startDate, endDate } = this.$refs.totalRegisteredDoctors.getDates();

            this.axios.post('Dashboard/GetTotalRegisteredDoctors',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalRegisteredDoctors(data.data);
            });
        },
        viewTotalRegisteredPatients () {
            let { startDate, endDate } = this.$refs.totalRegisteredPatients.getDates();

            this.axios.post('Dashboard/GetTotalRegisteredPatients',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalRegisteredPatients(data.data);
            });
        },
        viewTotalScheduledAppointments () {
            let { startDate, endDate } = this.$refs.totalScheduledAppointments.getDates();

            this.axios.post('Dashboard/GetTotalScheduledConsultations',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalScheduledConsultations(data.data);
            });
        },
        viewTotalPaidAppointments () {
            let { startDate, endDate } = this.$refs.totalPaidAppointments.getDates();

            this.axios.post('Dashboard/GetTotalPaidConsultations',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalPaidConsultations(data.data);
            });
        },
        viewTotalCancelledAppointments () {
            let { startDate, endDate } = this.$refs.totalCancelledAppointments.getDates();

            this.axios.post('Dashboard/GetTotalCancelledConsultations',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalCancelledConsultations(data.data);
            });
        },
        viewTotalCollectedConsultationAmount () {
            let { startDate, endDate } = this.$refs.totalCollectedConsultationAmount.getDates();

            this.axios.post('Dashboard/GetTotalCollectedConsultationAmount',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalCollectedConsultationAmount(data.data);
            });
        },
        viewTotalCollectedConsultationDoctorAmount () {
            let { startDate, endDate } = this.$refs.totalCollectedConsultationDoctorAmount.getDates();

            this.axios.post('Dashboard/GetTotalCollectedConsultationDoctorAmount',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalCollectedConsultationDoctorAmount(data.data);
            });
        },
        viewTotalCollectedPrescriptionAmount () {
            let { startDate, endDate } = this.$refs.totalCollectedPrescriptionAmount.getDates();

            this.axios.post('Dashboard/GetTotalCollectedPrescriptionAmount',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalCollectedPrescriptionAmount(data.data);
            });
        },
        viewTotalCollectedPrescriptionPharmacyAmount () {
            let { startDate, endDate } = this.$refs.totalCollectedPrescriptionPharmacyAmount.getDates();

            this.axios.post('Dashboard/GetTotalCollectedPrescriptionPharmacyAmount',
                {
                    'sd': startDate.toISOString(true),
                    'ed': endDate.toISOString(true)

                }).then(({ data }) => {
                this.setTotalCollectedPrescriptionPharmacyAmount(data.data);
            });
        }
    }
};
</script>

<style>

</style>
